import { Box, Button, Container, Divider, Typography } from '@mui/material'
import React from 'react'
import GridImage2 from '../../assets/png/grid-2.png'

const GaragePerfect = (props) => {
  return (
    <>
      {/* Grid 1 */}
      <Container>
        <Box sx={{ alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "space-between",}}>
          <Box sx={{display: "flex", flex: 1, justifyContent: "center", minWidth: 350, p: 5,}}>
            <Box>
              <Typography component="h2" variant="h2" fontSize={40} fontWeight={600}>The Perfect Garage.</Typography>
              <Typography width={350}>Plan the perfect garage storage space to organize your tools, gardening supplies, outdoor toys, and more. Rearrange the storage units to find the layout that suits your needs.</Typography>
              <Divider sx={{my:2,}} />
              <Typography component="h3" variant="h6" sx={{mb:1,}}>Step inside this garage by opening the project.</Typography>
              <Button href="https://designer.personalarch.com/home/shared_link?pid=67487af27770e730cd2100d3" target="_blank" variant="contained">Open Project</Button>
            </Box>
          </Box>
          <Box sx={{display: "flex", flex: 1, justifyContent: "center", p: 5,}}>
            <Box
              allowFullScreen
              component="iframe"
              sx={{
                minWidth: 350,
                maxWidth: 500,
                height: 350,
                display: "flex",
                flex: 1,
                borderRadius: 2,
              }}
              src="https://www.youtube.com/embed/Ugw_it1DbWg?si=LMM2KO4EOzSaoRJ9"
            />
          </Box>
        </Box>
      </Container>
      {/* Grid 2 */}
    </>
  )
}

export default GaragePerfect